import { motion } from 'framer-motion';

export default function LoadingSkeleton() {
  return (
    <div className="space-y-4">
      {[...Array(5)].map((_, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: i * 0.1 }}
          className="animate-pulse"
        >
          <div className="h-16 bg-gray-200 rounded-lg"></div>
        </motion.div>
      ))}
    </div>
  );
}
